import { Injectable, InjectionToken } from '@angular/core'
import { CmsComponent, Converter } from '@spartacus/core'
import { ConvertedComponentData, TextInput } from '../types'
import { CmsConverterService, defaultTextInput } from '../../services/cms-converter/cms-converter.service'

@Injectable({ providedIn: 'root' })
export class IntroTextConverter extends CmsConverterService<IntroTextData> {
  convertData (source: CmsComponent) {
    const formData = source?.otherProperties?.formData ?? {}
    return {
      label: formData.st_label ?? defaultTextInput,
      headline: formData.st_headline ?? defaultTextInput,
      text: formData.st_text ?? defaultTextInput,
      backgroundColor: formData.st_intro_text_background?.value?.identifier ?? ''
    }
  }
}

export const INTRO_TEXT_CONVERTER_TOKEN = new InjectionToken<Converter<CmsComponent, IntroTextData>>('IntroTextConverter')

export interface IntroTextData extends ConvertedComponentData {
  label: TextInput;
  headline: TextInput;
  text: TextInput;
  backgroundColor: TextInput;
}
